import { type ParsedElicitation } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/elicitation';
import { type WorkspaceAgentMessage } from '~/components/v2/components/workspace/workspace-agent-panel/types/workspaceAgentMessage';
import { getPendingConsentDockElicitation } from '~/components/v2/components/workspace/workspace-agent-panel/utils/getPendingConsentDockElicitation';

/**
 * Identity of the newest thread row so a streamed token or a newly merged message restarts the
 * stall clock. `id` alone would keep ticking through an in-place content update.
 */
export const getWorkspaceAgentLastMessageActivityKey = (messages: WorkspaceAgentMessage[]): string | null => {
  const lastMessage = messages.at(-1);

  if (lastMessage === undefined) {
    return null;
  }

  return `${lastMessage.id}:${lastMessage.content ?? ''}`;
};

export type HasWorkspaceAgentPendingApprovalParams = {
  pendingElicitations: ParsedElicitation[];
};

export const hasWorkspaceAgentPendingApproval = ({
  pendingElicitations,
}: HasWorkspaceAgentPendingApprovalParams): boolean => getPendingConsentDockElicitation(pendingElicitations) !== null;
